import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { environment } from "environments/environment";
import { rejectCatchError } from "../../reject-catch-error";
import { VerificationPhoneResponse } from "../../auth/interfaces/verification-phone.response";
import { nextPage, setConfirmedPhone } from "../credit.reducer";
import { sendPhoneCodeThunk } from "./send-phone-code.thunk";

export const isVerificationPhoneThunk = createAsyncThunk('credit/isVerificationPhone', async (phoneNumber: string, { dispatch, rejectWithValue }) => {
    try {
        const response = await axios.post<VerificationPhoneResponse>(environment.urls.isVerificate, { phoneNumber });
        if(response.data.isVerification) {
            dispatch(setConfirmedPhone({
                phone: response.data.phoneNumber,
                code: ''
            }));
            dispatch(nextPage());
        } else {
            dispatch(sendPhoneCodeThunk(response.data.phoneNumber));
        }
    } catch (error: any) {
        return rejectCatchError(error, rejectWithValue);
    }
})